/**
 * Enum representing action types for managing the shared application state.
 */
export enum StateActionType {
	/** Action to fetch data sources. */
	FETCH_SOURCES = 'fetchSources',

	/** Action to fetch layers (TODO layerTemplates?). */
	FETCH_LAYERS = 'fetchLayers',

	/** Action to fetch places */
	FETCH_PLACES = 'fetchPlaces',

	/** Action to fetch periods */
	FETCH_PERIODS = 'fetchPeriods',

	/** Action to fetch styles */
	FETCH_STYLES = 'fetchStyles',

	/** Action to update the application node. */
	APP_NODE = 'appNode',

	/** Action to change the active layer. */
	LAYER_ACTIVE_CHANGE = 'layerActiveChange',

	/** Action to update the global application state. */
	GLOBAL_STATE_UPDATE = 'globalStateUpdate',

	/** Action to apply a persistent state to the application. */
	APPLY_PERSISTENT_STATE = 'applyPersistentState',

	/** Action to change the map view (e.g., zoom, center, bounds). */
	MAP_VIEW_CHANGE = 'mapViewChange',

	/** Action to change the active map layer. */
	MAP_LAYER_ACTIVE_CHANGE = 'mapLayerActiveChange',

	/** Action to change the interactivity of a map layer. */
	MAP_LAYER_INTERACTIVITY_CHANGE = 'mapLayerInteractivityChange',

	/** Action to change the opacity of a map layer. */
	MAP_LAYER_OPACITY_CHANGE = 'mapLayerOpacityChange',

	/** Action to add layer to the map. */
	MAP_LAYER_ADD = 'mapLayerAdd',

	/** Action to remove layer from the map. */
	MAP_LAYER_REMOVE = 'mapLayerRemove',

	/** Action to set the feature key for a map layer. */
	MAP_LAYER_SET_FEATURE_KEY = 'mapLayerSetFeatureKey',

	/** Action to add a feature key to the map layer selections. */
	MAP_LAYER_ADD_FEATURE_KEY = 'mapLayerAddFeatureKey',

	/** Action to remove a feature key from the map layer selections. */
	MAP_LAYER_REMOVE_FEATURE_KEY = 'mapLayerRemoveFeatureKey',

	/** Action to set (replace) all feature keys for a map layer selection atomically. */
	MAP_LAYER_SET_FEATURE_KEYS = 'mapLayerSetFeatureKeys',

	/** Action to clear all feature keys from a map layer selection atomically. */
	MAP_LAYER_CLEAR_SELECTION = 'mapLayerClearSelection',

	/** Action to add map to map set */
	MAP_ADD_TO_MAP_SET = 'addMapToMapSet',

	/** Action to add map */
	MAP_ADD = 'addMap',

	/** Action to remove map from map set. */
	MAP_REMOVE_FROM_MAP_SET = 'removeMapFromMapSet',

	/** Action to remove maps from map set by keys. */
	MAP_SET_REMOVE_MAPS_BY_KEYS = 'mapSetRemoveMapsByKeys',

	/** Action to toggle or change map set synchronization. */
	MAP_SET_SYNC_CHANGE = 'mapSetSyncChange',

	/** Action to change the mode of a map set (e.g., slider, grid). */
	MAP_SET_MODE_CHANGE = 'mapSetModeChange',

	/** Action to add a new map set. */
	MAP_SET_ADD = 'mapSetAdd',

	/** Action to remove a map set. */
	MAP_SET_REMOVE = 'mapSetRemove',

	/** Action to update polygon/circle drawing state on a RenderingLayer. */
	GEOMETRY_DRAWING_UPDATE = 'geometryDrawingUpdate',

	/**
	 * Atomically set a named selection with explicit featureKeys and colour palette.
	 * When distinctItems is true each feature gets a cycling colour index;
	 * when false (default) all features share index 0.
	 */
	MAP_LAYER_SET_BULK_SELECTION = 'mapLayerSetBulkSelection',
}
